'use client';

import ShellRootHeader, { type RootHeaderProps } from '@upzi/web-shell/header';
import { UpziHeaderShellProvider } from '@/components/web-shell/upzi-header-shell-provider';

export type { RootHeaderProps } from '@upzi/web-shell/header';

export default function RootHeader(props: RootHeaderProps) {
  return (
    <UpziHeaderShellProvider>
      <ShellRootHeader {...props} />
    </UpziHeaderShellProvider>
  );
}
